import { useSelector } from "react-redux";
import {
  getFundScheduleChargeTypeSelectModels,
  selectFundScheduleChargeTypeSelectModels,
  selectLastUpdateTime,
  selectLoading,
} from "./components/FundScheduleChargeTypeSelectSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import useCaching, { CachingOptions } from "cpl-react-common/Hooks/useCaching";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import MultiSelectDropdown from "cpl-react-common/components/Inputs/MultiSelectDropdown";

type FundScheduleChargeTypeSelectProps = {
  "data-test-id"?: string;
  handleChange: (selections: number[]) => void;
  defaultAll: boolean;
  defaultSome?: number[];
  disabled?: boolean;
  fundScheduleChargeTypeID?: string[];
};

const EXPIRY_PERIOD_MS = 1000 * 60 * 60; // 1 hour

const FundScheduleChargeTypeSelectMulti: React.FC<FundScheduleChargeTypeSelectProps> = (props) => {
  const thunkDispatch = useThunkDispatch();
  const loading = useSelector(selectLoading);
  const fundScheduleChargeTypeSelectModels = useSelector(selectFundScheduleChargeTypeSelectModels);
  const lastUpdateTime = useSelector(selectLastUpdateTime);

  const updateSelectModels = () => {
    thunkDispatch(getFundScheduleChargeTypeSelectModels());
  };

  const cachingOptions: CachingOptions = {
    lastUpdateTime,
    expiryPeriodMs: EXPIRY_PERIOD_MS,
    updateData: updateSelectModels,
    shouldUpdateOnLoad: fundScheduleChargeTypeSelectModels.length === 0,
  };

  useCaching(cachingOptions);

  const options = fundScheduleChargeTypeSelectModels.map((x) => ({
    value: x.value!,
    label: x.label ?? "",
  }));

  return (
    <ActivityIndicator isBusy={loading}>
      <MultiSelectDropdown
        data-test-id={props["data-test-id"]}
        handleChange={(selections) => {
          if (options.length == 0) return;
          props.handleChange(selections as number[]);
        }}
        options={options}
        defaultAll={props.defaultAll}
        defaultSome={props.defaultSome}
        searchable={true}
      ></MultiSelectDropdown>
    </ActivityIndicator>
  );
};

export default FundScheduleChargeTypeSelectMulti;
